import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    padding: 12,
    background: '#ffffff',
    flex: 1,
    border: '1px solid #D9D9D9',
    fontSize: 12,
    lineHeight: '22px',
  },
}));
